import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AtalhoConversa } from '../shared/abstract/atalho-conversa';
import { FotoProvider } from '../../providers/foto/foto';
import { ConversaUsaurio } from '../../models/area';
import { NavProxyProvider } from '../../providers/nav-proxy/nav-proxy';
import { ConversaAreaUsuarioPage } from '../../pages/conversa-area-usuario/conversa-area-usuario';
//import { ConversaAreaUsuarioPage } from '../../pages/conversa-area-usuario/conversa-area-usuario';

@Component({
  selector: 'conversa-area-usuario',
  templateUrl: 'conversa-area-usuario.html'
})
export class ConversaAreaUsuarioComponent extends AtalhoConversa {

  @Input() conversaUsuario: ConversaUsaurio;
  @Input() idArea: number;
  @Output() quantidadeMensagensNaoLidas: EventEmitter<number>;

  constructor(private navProxyProvider: NavProxyProvider, private fotoProvider: FotoProvider) {
    super();
    this.quantidadeMensagensNaoLidas = new EventEmitter();
  }

  ngOnInit() {
    this.atualizarUltimaMensagem(this.conversaUsuario.mensagens);
  }

  protected atualizarNumMensagensNaoLidas(): void {
    if (this.conversaUsuario.mensagens) {
      this._quantidadeMensagensNaoLidas = this.conversaUsuario.mensagens.filter(m => m.origem === "L"
      && !m.statusMensagemLida).length;
      this.quantidadeMensagensNaoLidas.emit(this._quantidadeMensagensNaoLidas);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.atualizarUltimaMensagem(this.conversaUsuario.mensagens);
  }

  public abrirConversa(): void {
      this.navProxyProvider.pushContent(ConversaAreaUsuarioPage, {
        conversaUsuario: this.conversaUsuario,
        idArea: this.idArea 
      });
  }

  public getFotoPerfil(): string {
    if (!this.conversaUsuario.hashImagem) {
      return "assets/img/usuario.png";
    }
    return this.fotoProvider.getUrlImagemServidor(this.conversaUsuario.hashImagem);
  }

}



// WEBPACK FOOTER //
// ./src/components/conversa-area-usuario/conversa-area-usuario.ts